import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { Instagram } from "lucide-react";

const PHOTOS = [
  { src: "/knickerbocker-glory.webp", alt: "A Morelli's Knickerbocker Glory in the pink parlour booth", caption: "The famous Glory" },
  { src: "/gallery-espresso.webp", alt: "Morelli's espresso tins beside a caramel sundae", caption: "Gelato & espresso" },
  { src: "/parlour-interior.webp", alt: "Golden evening light flooding the Morelli's parlour", caption: "Golden hour inside" },
  { src: "/gallery-plates.webp", alt: "The parlour's vintage wall of etched glass dessert plates", caption: "The plate wall" },
  { src: "/viking-bay.webp", alt: "A bustling summer day on Viking Bay beach, Broadstairs", caption: "Viking Bay in full swing" },
  { src: "/sundae-coupe.webp", alt: "A Morelli's sundae with chocolate-dipped strawberries", caption: "Chocolate-dipped" },
  { src: "/gallery-mural.webp", alt: "The parlour's hand-painted Venetian canal mural", caption: "Venezia, remembered" },
  { src: "/parlour-night.webp", alt: "The Morelli's neon sign glowing over the promenade at night", caption: "Neon nights" },
  { src: "/gallery-sconce.webp", alt: "An ice cream cone wall sconce glowing on the parlour wall", caption: "Cone sconce glow" },
  { src: "/parlour-exterior.webp", alt: "The iconic Morelli's seafront parlour by day", caption: "The iconic frontage" },
  { src: "/gallery-cantuccini.webp", alt: "Cantuccini and festive treats on the parlour counter", caption: "Cantuccini season" },
];

const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="py-28 md:py-36 bg-white/60">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHeading chapter="06" overline="The Gallery" title="Life at the Parlour" align="center" />
      <Reveal delay={0.1}>
        <a href="https://www.instagram.com/morellisbroadstairs/" target="_blank" rel="noopener noreferrer" data-testid="gallery-instagram-link"
          className="mt-6 mx-auto flex w-fit items-center gap-2 text-xs uppercase tracking-[0.25em] text-teal/70 hover:text-gold transition-colors duration-300">
          <Instagram size={16} /> @morellisbroadstairs
        </a>
      </Reveal>
      <div className="mt-14 columns-2 md:columns-3 gap-5 space-y-5">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.src} delay={Math.min(i * 0.05, 0.35)} className="break-inside-avoid">
            <figure data-testid={`gallery-item-${i}`} className="group relative overflow-hidden rounded-[1.5rem] shadow-md shadow-teal/10">
              <img src={p.src} alt={p.alt} loading="lazy"
                className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <figcaption className="absolute inset-0 bg-teal/70 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-5">
                <span className="font-display italic text-cream text-lg">{p.caption}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
